import { ProFormColumnsType } from '@ant-design/pro-components';
import { createCurrencyFormItem } from '../createCurrencyFormItem';
import { createNumberFormItem, createTextFormItem } from './createTextFormItem';

export const payeEmployeeFormSchema = (): ProFormColumnsType[] => [
  {
    valueType: 'group',
    columns: [
      ...['companyName', 'occupation'].map(item => createTextFormItem(item, 'member.income')),
      ...['timeInJob'].map(item => createNumberFormItem(item, 'member.income')),
      createCurrencyFormItem(null, 'basicIncome', 'member.income', undefined, true),
      ...['employersAllowance', 'bonus', 'commission', 'overtime'].map(item =>
        createCurrencyFormItem(null, item, 'member.income', 'yearly', true),
      ),
    ],
  },
];
